<template>
  <li class="card -training" :class="{ '-light': training.ended }">
    <ScopedLink :to="getTo()" class="row" :aria-label="`Plus d'infos ${training.title})`">
      <div v-if="!training.ended" class="card__medias">
        <Image v-if="training.image" :source="training.image" class="card__medias__image -normal" />
      </div>
      <div class="card__content">
        <div class="row -spread">
          <h2 class="card__title">
            <span v-if="training.ended" class="card__tag">{{ labels.ended }}</span
            >{{ training.title }}
          </h2>
          <div
            class="card__medias__link link -after"
            :style="{ position: theme ? 'absolute' : 'initial' }"
          >
            <span>{{ labels.info }}</span>
            <Icon id="leaves" />
          </div>
        </div>

        <p v-if="sponsors.length" class="card__creator">
          <span>{{ `${labels.offered_by} ` }}</span>
          <span v-for="(sponsor, i) in sponsors" :key="sponsor.id">
            {{ sponsor.name }}<span v-if="i !== sponsors.length - 1">, </span>
          </span>
        </p>

        <p v-if="!theme">{{ training.excerpt }}</p>

        <div class="card__date">
          <p class="card__status">
            <Icon id="internal" />
            {{ categoryLabel }}
          </p>

          <p class="card__status -calendar" v-if="!theme">
            <Icon id="calendar" />
            {{ training.date }}
          </p>
        </div>
      </div>
    </ScopedLink>
  </li>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import ScopedLink from '@/components/global/ScopedLink.vue'
import { distributionModesDict } from '@/constants'

export default {
  name: 'TrainingCard',
  components: { Image, Icon, ScopedLink },
  props: {
    training: { type: Object, required: true },
    labels: {
      type: Object,
      required: true,
    },
    theme: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    categoryLabel() {
      const slug = this.training.category || ''
      return distributionModesDict[slug]
    },
    sponsors() {
      const { sponsors = [] } = this.training || {}
      return sponsors.map((sponsorId) => this.$beet.sponsors[sponsorId])
    },
  },
  methods: {
    getTo() {
      return this.training.external
        ? this.training.url
        : { name: 'training', params: { trainingSlug: this.training.slug } }
    },
  },
}
</script>
